import { ReactNode, SubmitEvent } from "react";

import * as S from "./styled";

type FormProps = {
  onSubmit: (event: SubmitEvent<HTMLFormElement>) => void | Promise<void>;
  children: ReactNode;
};

export const Form = ({ onSubmit, children }: FormProps) => {
  return <S.Form onSubmit={(event) => void onSubmit(event)}>{children}</S.Form>;
};

type FieldGroupProps = {
  title?: string;
  columns?: number;
  children: ReactNode;
};

export const FieldGroup = ({
  title,
  children,
  columns = 1,
}: FieldGroupProps) => {
  if (columns < 1) {
    throw new Error("columns must be greater than 0");
  }

  const titleEl = title ? <S.Title>{title}</S.Title> : null;

  return (
    <div>
      {titleEl}
      <S.Fields $columns={columns}>{children}</S.Fields>
    </div>
  );
};
